export const sourceFileUploadTypeList = [
    {
        label: '否', // 未上传
        value: 0
    },
     {
        label: '是', // 上传
        value: 1
    },
]
export const sourceFileUploadTypeFilter = (value) => {
    const item = sourceFileUploadTypeList.find(item => item.value === value)
    return item ? item.label : '-'
}